import React from "react";

// Shared selectable list for the Create Trivvy modal: the "Built with AI"
// survey prompts (CreateTriviaPopup) and the Messaging sample messages
// (CreateCustomTrivvyPopup) render the identical list, so it lives here once
// rather than being copied into both — the two screens can't drift apart.
//
// `items` are `{ title, description }`. `onSelect` receives the whole item, so
// each screen keeps its own behaviour: the survey screen fills the prompt
// textarea, Messaging fills the message body, title and (if untouched) name.
//
// `actionLabel` names what selecting a row does ("Insert as prompt" /
// "Insert Text"). The card these rows replaced carried that label in a footer,
// and it was the only affordance saying a row was clickable — so it is required
// content, not decoration.
//
// The list itself scrolls via `.bwai_prompt_list` — do NOT wrap it in another
// scrolling container or the two scrollbars fight.
// `selectedTitle` marks the row already chosen, so a list the user comes back
// to shows which one they picked rather than looking untouched.
const BwaiPromptList = ({
  items,
  onSelect,
  actionLabel,
  className,
  selectedTitle,
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  const handleSelect = (item) => {
    if (onSelect) {
      onSelect(item);
    }
  };

  return (
    <ul className={`bwai_prompt_list list-unstyled ${className || ""}`}>
      {items.map((item, index) => (
        <li
          className={`bwai_prompt_item${
            selectedTitle && selectedTitle === item.title ? " is-selected" : ""
          }`}
          key={index}
          role="button"
          tabIndex={0}
          aria-pressed={selectedTitle ? selectedTitle === item.title : undefined}
          onClick={() => handleSelect(item)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              // The list scrolls, so Space would otherwise select AND page it
              // down at the same time.
              e.preventDefault();
              handleSelect(item);
            }
          }}
        >
          <span className="bwai_prompt_body">
            <span className="bwai_prompt_title d-block">{item.title}</span>
            <span className="bwai_prompt_desc d-block">{item.description}</span>
          </span>
          {actionLabel && (
            <span className="bwai_prompt_action">{actionLabel}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default BwaiPromptList;
